<div class="modal-body form-modal-body competency-calendar-modal">
  <div class="skylark-modal-header">
    <h4>Upload Document</h4>
    <button type="button" class="icon" (click)="closeModal()"><span class="pi pi-times"></span></button>
  </div>

  <div class="competency-modal-preview" *ngIf="competency">
    <div class="competency-modal-preview__header">{{ competency.type }}</div>
    <div class="competency-modal-preview__body">
      <div class="competency-card__badge competency-modal-preview__badge"
        [attr.style]="'--competency-badge-color: ' + (competency.name | competencyBadgeColor) | safestyle">
        {{ competency.name }}
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.oem">
        <span class="competency-card__label">OEM:</span>
        <span>{{ competency.oem }}</span>
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.model">
        <span class="competency-card__label">Model:</span>
        <span>{{ competency.model }}</span>
      </div>
      <div class="competency-modal-preview__detail" *ngIf="competency.rating">
        <span class="competency-card__label">Rating:</span>
        <span>{{ competency.rating }}</span>
      </div>
    </div>
    <div class="competency-modal-preview__status competency-card__status--unverified">
      Unverified<ng-container *ngIf="competency.expiryDate">: {{ competency.expiryDate | date: 'MMM dd, y' }}</ng-container>
    </div>
  </div>

  <p class="mt-3"><b>Upload supporting document</b></p>

  <div class="row form-row">
    <div class="col-md-12">
      <div class="form-group">
        <label class="modal-label"><b>Document</b> <span class="required-text">(required)</span></label>
        <div class="doc-control">
          <div class="doc-upload" (click)="docInput.click()">
            <span class="doc-placeholder" *ngIf="!selectedDocument">Upload document...</span>
            <span class="doc-placeholder" *ngIf="selectedDocument">{{ selectedDocument.name }}</span>
            <i class="pi pi-upload"></i>
          </div>
          <input
            #docInput
            type="file"
            class="doc-file-input"
            (change)="onFileSelected($event)"
            accept=".pdf, image/*, .doc, .docx, .ppt, .pptx, .odt, .xls, .xlsx"
          />
        </div>
      </div>
    </div>
  </div>
  <div class="row form-row">
    <div class="col-md-12">
      <div class="form-group">
        <label class="modal-label"><b>Expires</b> <span class="required-text">(required)</span></label>
        <p-calendar
          [(ngModel)]="expiryDate"
          [minDate]="today"
          dateFormat="dd/mm/yy"
          [yearNavigator]="true"
          [yearRange]="datepickerYearRange"
          [monthNavigator]="true"
          placeholder="Select date..."
          [showIcon]="true"
          [style]="{'width':'100%'}"
          [inputStyle]="{'width':'100%'}">
        </p-calendar>
        <small class="text-danger" *ngIf="isExpiryDateInPast">Please choose a future date.</small>
      </div>
    </div>
  </div>

  <p-footer>
    <button type="button" class="btn btn-round btn-outline-default" [disabled]="saveInProgress" (click)="closeModal()">Cancel</button>
    <button type="button" class="btn btn-round btn-success" [disabled]="saveInProgress || !selectedDocument || !expiryDate || isExpiryDateInPast" (click)="upload()">Upload</button>
  </p-footer>
</div>
